import { useEffect, useState, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './login.less';
import { LoginContext } from '@/context/LoginContext';
import { setToken } from '@/utils/cookie.js';
import GoogleImg from '@/assets/layouts/account/google.png';
import EmailImg from '@/assets/layouts/account/email.png';
import LogoImg from '@/assets/layouts/account/logotype.png';
import { authService } from '@/api/index';
import message from '@/utils/message';
import WebSocketContext from '@/context/WebSocketContext';
import { CookiesTrackingCode } from '@/utils/cookie';
// Add utility functions for mobile detection and rem conversion
import { useTranslation } from 'react-i18next';
const isMobileDevice = () => {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    window.innerWidth < 766
  ); // Common breakpoint for mobile devices
};

// Function to convert px to rem for mobile devices only
const mobileRem = (px) => {
  if (isMobileDevice()) {
    // Base font size is typically 16px, adjust according to your design
    return `${px / 16}rem`;
  }
  return `${px}px`; // Return px value for desktop
};

// Hook to handle responsive sizing
const useResponsiveSizing = () => {
  const [isMobile, setIsMobile] = useState(isMobileDevice());

  useEffect(() => {
    const handleResize = () => {
      console.log(isMobileDevice(), 'isMobileDevice()');
      if (isMobileDevice()) {
        // You can adjust the base font size calculation based on device width
        // setTimeout(() => {
        const fontSize = document.documentElement.clientWidth / 375; // 375px is typical design width for mobile
        document.documentElement.style.fontSize = `${fontSize}px`;
        // });
      } else {
        // setTimeout(() => {
        document.documentElement.style.fontSize = `16px`;
        // });
      }
      setIsMobile(isMobileDevice());
    };
    if (isMobile) {
      // You can adjust the base font size calculation based on device width
      // setTimeout(() => {
      const fontSize = document.documentElement.clientWidth / 375; // 375px is typical design width for mobile
      document.documentElement.style.fontSize = `${fontSize}px`;
      // });
    } else {
      // setTimeout(() => {
      document.documentElement.style.fontSize = `16px`;
      // }, 50);
    }
    window.addEventListener('resize', handleResize);
    message.close();
    // Set initial font size for root element if mobile

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { isMobile, mobileRem };
};

export default function Login() {
  const { loginShowType } = useContext(LoginContext);
  const { isMobile } = useResponsiveSizing();
  useEffect(() => {
    document.body.classList.toggle('mobile-device', isMobile);
  }, [isMobile]);
  useEffect(() => {
    sessionStorage.removeItem('register');
  }, []);
  return (
    <div className={`${isMobile ? 'mobile' : 'loginBox'}`}>
      <div className="account_header_logo">
        <img
          src={LogoImg}
          alt=""
          onClick={() => {
            location.href = 'https://www.addsubtitle.ai';
          }}
        />
      </div>
      <div style={{ display: loginShowType === 0 ? 'block' : 'none' }}>
        <SelectLoginType isMobile={{ isMobile }} />
      </div>
      <div style={{ display: loginShowType === 1 ? 'block' : 'none' }}>
        <EmailLogin isMobile={{ isMobile }} />
      </div>
      <div style={{ display: loginShowType === 2 ? 'block' : 'none' }}>
        <EmailCode isMobile={{ isMobile }} />
      </div>
      {/* {loginShowType === 0 &&}
      {loginShowType === 1 && <EmailLogin isMobile={{ isMobile }} />}
      {loginShowType === 2 && <EmailCode isMobile={{ isMobile }} />} */}
      <div className="loginBGBlock" />
    </div>
  );
}

function SelectLoginType() {
  const { t } = useTranslation();
  const { isMobile } = useResponsiveSizing();
  const { setLoginShowType } = useContext(LoginContext);
  const queryString = window.location.search;
  // const navigate = useNavigate();
  const [googleLoading, setGoogleLoading] = useState(false);
  const googleLoginUri = `${location.origin}/api/oauth/google`;
  const obj = {};
  obj.source = sessionStorage.getItem('source');
  obj.campaign = sessionStorage.getItem('campaign');
  obj.term = sessionStorage.getItem('term');
  obj.ad = sessionStorage.getItem('ad');
  obj.redirectUri = encodeURI(googleLoginUri);
  // obj.recall = sessionStorage.getItem('recall');
  // if (sessionStorage.getItem('feature')) {
  //   obj.path = 'tool';
  // }
  const searchParams = new URLSearchParams(queryString);
  for (const [key, value] of searchParams) {
    obj[key] = value;
  }
  const state = btoa(encodeURIComponent(JSON.stringify(obj)));

  const handleGoogleLogin = async () => {
    if (googleLoading) {
      return;
    }
    window.onClickGATrackEvent('login-google-click');
    setGoogleLoading(true);
    const oauth2Endpoint = 'https://accounts.google.com/o/oauth2/v2/auth';

    // Create <form> element to submit parameters to OAuth 2.0 endpoint.
    const form = document.createElement('form');
    form.setAttribute('method', 'GET'); // Send as a GET request.
    form.setAttribute('action', oauth2Endpoint);

    // Parameters to pass to OAuth 2.0 endpoint.
    const params = {
      client_id: '375782144745-60viikk2fg5g49n6i85qcd2lsk0fpkol.apps.googleusercontent.com',
      redirect_uri: googleLoginUri,
      response_type: 'code',
      scope: 'openid profile email',
      include_granted_scopes: 'true',
      state: state,
      prompt: 'select_account',
    };

    // Add form parameters as hidden input values.
    for (const p in params) {
      const input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', p);
      input.setAttribute('value', params[p]);
      form.appendChild(input);
    }

    // Add form to page and submit it to open the OAuth 2.0 endpoint.
    document.body.appendChild(form);
    form.submit();
    setTimeout(() => {
      setGoogleLoading(false);
    }, 500);
  };
  const handleEmailLogin = () => {
    window.onClickGATrackEvent('login-email-click');
    setLoginShowType(1);
  };
  return (
    <div className="select_login_type_box">
      <div className="title">
        <div className="text">{t('As_Edit_BrandSloganHalf1')}</div>
        <div className="text">{t('As_Edit_BrandSloganHalf2')}</div>
      </div>
      <div className="title_info">{t('As_Login&SignupPage_CTA')}</div>
      <div className="btn_box">
        <button className="diy_google_btn" onClick={handleGoogleLogin}>
          {googleLoading && (
            <div className="google_loading_box">
              <span className="loading"></span>
            </div>
          )}
          <img src={GoogleImg} alt="Google" />
          <span>{t('As_Login&SignupPage_LoginChoice1')}</span>
          <div id="googleBtn" className="google_btn"></div>
        </button>
        <button className="email_btn" onClick={handleEmailLogin}>
          <img src={EmailImg} alt="Google" />
          <span>{t('As_Login&SignupPage_LoginChoice2')}</span>
        </button>
      </div>
      <div className="text_info">
        {isMobile ? (
          <>
            {t('As_Login&SingupPage_AgreementReminder')}{' '}
            <span
              onClick={() => {
                // 使用条款
                window.open('https://addsubtitle.ai/terms-of-use', '_blank');
              }}>
              {t('As_Login&SingupPage_TermofUse')}
            </span>
            {t('As_Login&SingupPage_ReadInstruction')}{' '}
            <span
              onClick={() => {
                // 隐私协议
                window.open('https://addsubtitle.ai/privacy-policy', '_blank');
              }}>
              {t('As_Login&SignupPage_PrivPolicy')}
            </span>
          </>
        ) : (
          <>
            {t('As_Login&SingupPage_AgreementReminder')}{' '}
            <span
              onClick={() => {
                // 使用条款
                window.open('https://addsubtitle.ai/terms-of-use', '_blank');
              }}>
              {t('As_Login&SingupPage_TermofUse')}
            </span>
            <br />
            {t('As_Login&SingupPage_ReadInstruction')}{' '}
            <span
              onClick={() => {
                // 隐私协议
                window.open('https://addsubtitle.ai/privacy-policy', '_blank');
              }}>
              {t('As_Login&SignupPage_PrivPolicy')}
            </span>
          </>
        )}
      </div>
    </div>
  );
}

function EmailLogin() {
  const { t } = useTranslation();
  const { isMobile } = useResponsiveSizing();
  const {
    loginShowType,
    setLoginShowType,
    email,
    setEmail,
    setBeginCountdown,
    setCountdownNum,
    countdownNum,
  } = useContext(LoginContext);
  const [warningText, setWarningText] = useState('');
  const [emailCheck, setEmailCheck] = useState(false);
  const [loading, setloading] = useState(false);
  // const { executeRecaptcha } = useGoogleReCaptcha();

  const handleInputEmail = (val) => {
    setEmailCheck(false);
    setWarningText('');
    setEmail(val.target.value);
  };
  const handleEnterPress = (e) => {
    if (e.key === 'Enter' && loginShowType === 1) {
      handleSubmit();
    }
  };
  // 创建全局键盘回车事件监听
  useEffect(() => {
    document.addEventListener('keydown', handleEnterPress);
    return () => {
      document.removeEventListener('keydown', handleEnterPress);
    };
  }, [loginShowType, email]);
  const handleCheckEmail = () => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email) && email) {
      setEmailCheck(true);
      setWarningText(t('As_Login&SignupPage_InvalidEmailAddressReminder'));
      return false;
    }
    if (emailCheck && email) {
      setEmailCheck(false);
      setWarningText('');
    }
    return true;
  };
  // 返回选择登录方式
  const handleBack = () => {
    setLoginShowType(0);
    window.onClickGATrackEvent('signin-email-back');
  };
  const handliContinue = async () => {
    setloading(true);
    try {
      const res = await authService.authEmailCode({
        email,
        language: localStorage.getItem('i18nextLng'),
      });
      console.log(res);
      if (res.code === 0) {
        setCountdownNum(60);
        setBeginCountdown(Date.now());
        setLoginShowType(2);
        sessionStorage.setItem('loginEmail', email);
      }
    } catch (error) {
      if (!error) return;
      console.log(error);

      const err = JSON.parse(error);
      if (err.code === -112) {
        message.warning(`Verification failed`, {
          isMobile,
        });
      }
    }
    setloading(false);
  };

  // 处理表单提交
  const handleSubmit = async () => {
    if (loading) return;
    if (!handleCheckEmail()) return;
    if (!email) {
      setEmailCheck(true);
      setWarningText(t('As_Login&SignupPage_InvalidEmailAddressReminder'));
      return;
    }

    // 如果在倒计时当中就不需要获取接口直接进入验证码页面
    if (countdownNum < 60 && countdownNum > 0 && email === sessionStorage.getItem('loginEmail')) {
      setBeginCountdown(Date.now());
      setLoginShowType(2);
      return;
    }
    // if (!executeRecaptcha) {
    //   console.log('reCAPTCHA 尚未准备好');
    //   return;
    // }
    window.onClickGATrackEvent('signin-email-continue');
    handliContinue();
  };
  return (
    <div className="email_login_box">
      <div className="title">{t('As_Login_ContinueEmail334')}</div>
      <div className="title_info">{t('As_Login_ContinueEmailDesc334')}</div>
      <input
        type="email"
        value={email}
        placeholder={t('As_Login_EmailAddress334')}
        onInput={handleInputEmail}
        onBlur={handleCheckEmail}
        name="email"
        autoComplete="email"
        className={`email_ipt  ${emailCheck && 'email_ipt_error'}`}
      />
      {emailCheck && <div className="warning_text">{warningText}</div>}
      {!emailCheck && <div className="warning_text_none"></div>}
      <button className="btn btn-primary continue_btn" onClick={handleSubmit}>
        {loading && <span className="loading loading-spinner loading-sm"></span>}
        {t('As_Login&SignupPage_Proceeding')}
      </button>
      <div className="back_box" onClick={handleBack}>
        &lt; {t('As_Login&SignupPage_Backward')}
      </div>
    </div>
  );
}

function EmailCode() {
  const { t } = useTranslation();
  const { isMobile } = useResponsiveSizing();
  const navigate = useNavigate();
  const { setWsConnect } = useContext(WebSocketContext);
  const {
    loginShowType,
    setLoginShowType,
    email,
    setEmailCode,
    countdownNum,
    setCountdownNum,
    setBeginCountdown,
  } = useContext(LoginContext);
  const [warningText, setWarningText] = useState('');
  const [codeChars, setCodeChars] = useState(Array(6).fill(''));
  const [emailCodeCheck, setEmailCodeCheck] = useState(false);
  const [isComposing, setIsComposing] = useState(false); // 添加中文输入法合成状态跟踪
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);

  // 创建对输入框的引用
  const inputRefs = useRef([]);
  const length = 6; // 添加length变量，因为原代码中有使用但未定义

  // 初始化refs数组
  useEffect(() => {
    if (loginShowType === 2) {
      inputRefs.current = inputRefs.current.slice(0, 6);
      // 处理自动聚焦
      if (inputRefs.current[0]) {
        inputRefs.current[0].focus();
      }
    }
  }, [loginShowType]);
  const isCodeComplete = () => {
    return codeChars.every((char) => char !== '');
  };

  useEffect(() => {
    const completeCode = codeChars.join('');
    setEmailCode(completeCode);
    if (isCodeComplete() && completeCode.length === 6) {
      console.log('提交验证码');
      window.onClickGATrackEvent('signin-email-verifycode-submit');
      submitLoginInfo(completeCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codeChars]);

  useEffect(() => {
    if (loading) {
      inputRefs.current.forEach((ref) => {
        if (ref) {
          ref.blur(); // 使每个输入框失去焦点
        }
      });
    }
  }, [loading]);

  const submitLoginInfo = async (val) => {
    if (loading) return;
    setLoading(true);

    try {
      const res = await authService.newLogin({
        email,
        captchaCode: val,
        recall: sessionStorage.getItem('recall') || null,
      });
      console.log(res);
      if (res.code === 0) {
        setToken(res.data.token);
        sessionStorage.setItem('recall', null);
        setWsConnect(Date.now());
        navigate('/home');
        if (res.data.register) {
          const tracking_code = CookiesTrackingCode();
          window.onClickGATrackEvent('signup-mail-success', {
            tracking_code,
          });
        } else {
          window.onClickGATrackEvent('login-mail-success');
        }
      }
    } catch (error) {
      const err = JSON.parse(error);
      console.log(err);
      if (err.code === -3) {
        setEmailCodeCheck(true);
        setWarningText(t('As_Login&SignupPage_IncorrectCodeReminder'));
      }
      if (err.code === -110) {
        setEmailCodeCheck(true);
        setWarningText(t('As_Login&SignupPagfe_CodeexpiredReminder'));
      }
    }
    setLoading(false);
  };

  const validateInput = (value) => {
    return /^[a-zA-Z0-9]*$/.test(value);
  };
  // 添加中文输入法合成事件处理
  // const handleCompositionStart = () => {
  //   setIsComposing(true);
  // };

  // const handleCompositionEnd = () => {
  //   setIsComposing(false);
  // };
  const handleInputChange = (index, event) => {
    setEmailCodeCheck(false);
    setWarningText('');
    const { value } = event.target;
    const isDirectChar = /[a-zA-Z0-9]/.test(value);

    // 如果当前在组合状态，但检测到了直接输入字符
    if (isComposing && isDirectChar) {
      setIsComposing(false);
      return;
    }
    // if (isComposing) {
    //   return;
    // }

    // 处理多字符输入（例如从剪贴板复制粘贴到单个输入框）
    if (value.length > 1) {
      const chars = value.split('');
      const newCodeChars = [...codeChars];

      // 只保留有效字符
      const validChars = chars.filter((char) => validateInput(char));

      // 填充验证码
      for (let i = 0; i < validChars.length && index + i < length; i++) {
        newCodeChars[index + i] = validChars[i];
      }

      setCodeChars(newCodeChars);

      // 聚焦到最后填充的格子之后
      const nextIndex = Math.min(index + validChars.length, length - 1);
      setTimeout(() => {
        inputRefs.current[nextIndex]?.focus();
      }, 0);

      return;
    }

    // 单字符处理
    const lastChar = value.slice(-1);

    // 验证输入
    if (lastChar && !validateInput(lastChar)) {
      return;
    }

    // 更新当前位置的字符
    const newCodeChars = [...codeChars];
    newCodeChars[index] = lastChar.toUpperCase();
    setCodeChars(newCodeChars);

    // 如果输入了字符且不是最后一格，自动跳到下一格
    if (lastChar && index < length - 1) {
      // 使用setTimeout确保在DOM更新后再聚焦
      setTimeout(() => {
        if (inputRefs.current[index + 1]) {
          inputRefs.current[index + 1].focus();
        }
      }, 10);
    }
  };

  const handleKeyDown = (index, event) => {
    // 处理退格键
    if (event.key === 'Backspace') {
      const newCodeChars = [...codeChars];

      // 如果当前输入框有值，清空它
      if (newCodeChars[index]) {
        newCodeChars[index] = '';
        setCodeChars(newCodeChars);
        setEmailCodeCheck(false);
        setWarningText('');
      }
      // 如果当前输入框为空且不是第一个，返回上一个
      else if (index > 0) {
        setTimeout(() => {
          if (inputRefs.current[index - 1]) {
            newCodeChars[index - 1] = '';
            setCodeChars(newCodeChars);
            inputRefs.current[index - 1].focus();
          }
        }, 10);
      }
    }

    // 支持左右箭头键导航
    if (event.key === 'ArrowLeft' && index > 0) {
      if (!inputRefs.current[index - 1].value) {
        return;
      }
      setTimeout(() => {
        inputRefs.current[index - 1]?.focus();
      }, 10);
    }

    if (event.key === 'ArrowRight' && index < length - 1) {
      if (!inputRefs.current[index + 1].value) {
        if (!inputRefs.current[index].value) {
          return;
        }
      }
      setTimeout(() => {
        inputRefs.current[index + 1]?.focus();
      }, 10);
    }
  };

  const handlePaste = (startIndex, event) => {
    event.preventDefault();
    const pasteData = event.clipboardData.getData('text').trim();

    // 根据类型过滤粘贴的内容
    const filteredChars = pasteData.replace(/[^a-zA-Z0-9]/g, '');

    // 填充验证码
    const newCodeChars = [...codeChars];
    for (let i = 0; i < filteredChars.length && startIndex + i < length; i++) {
      newCodeChars[startIndex + i] = filteredChars[i].toUpperCase();
    }
    setCodeChars(newCodeChars);

    // 焦点设置到最后一个填充的输入框之后
    const nextFocusIndex = Math.min(startIndex + filteredChars.length, length - 1);
    setTimeout(() => {
      if (inputRefs.current[nextFocusIndex]) {
        inputRefs.current[nextFocusIndex].focus();
      }
    }, 10);
  };

  const getInputMode = () => {
    return 'text';
  };

  const getInputPattern = () => {
    return '[a-zA-Z0-9]*';
  };
  // 返回邮箱输入
  const handleBack = () => {
    setLoginShowType(1);
    setCodeChars(Array(6).fill(''));
    setEmailCodeCheck(false);
    setWarningText('');
    window.onClickGATrackEvent('signin-email-verifycode-back');
  };
  const handleResendNum = async () => {
    if (resendLoading) return;
    setResendLoading(true);
    try {
      const res = await authService.authEmailCode({
        email,
        language: localStorage.getItem('i18nextLng'),
      });
      console.log(res);
      if (res.code === 0) {
        setCountdownNum(60);
        setBeginCountdown(Date.now());
        message.success(t('As_Login&SignupPage_CodeCorrectlyConfirmed'), {
          isMobile,
        });
      }
    } catch (error) {
      const err = JSON.parse(error);
      console.log(err);
    }
    setResendLoading(false);
  };

  return (
    <div className="email_code_box">
      <div className="title">{t('As_Login_FinishLogin334')}</div>
      <div className="title_info">
        {t('As_Login_SendedFirst334')}&nbsp;<span>{email}</span>
        {t('As_Login_SendedSecond334')}
      </div>
      <div className="verification_code_container">
        {codeChars.map((char, index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            type="text"
            disabled={loading}
            className={`code_input ${emailCodeCheck && 'code_err'}`}
            inputMode={getInputMode()}
            pattern={getInputPattern()}
            // onCompositionStart={handleCompositionStart}
            // onCompositionEnd={handleCompositionEnd}
            maxLength={1}
            value={char}
            onMouseDown={(e) => {
              const firstEmptyIndex = codeChars.findIndex((char) => char === '');
              if (firstEmptyIndex !== -1 && inputRefs.current[firstEmptyIndex]) {
                inputRefs.current[firstEmptyIndex].focus();
              }
              if (index !== 0 && !e.target.value) {
                e.preventDefault(); // 阻止默认行为
              }
            }}
            // style={{ caretColor: 'transparent' }} // 隐藏输入框光标
            onChange={(e) => handleInputChange(index, e)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={(e) => handlePaste(index, e)}
            // aria-label={`Verification code digit ${index + 1}`}
          />
        ))}
      </div>
      {emailCodeCheck && <div className="warning_text">{warningText}</div>}
      {!emailCodeCheck && <div className="warning_text_none"></div>}
      <div className="btn_box">
        {!isMobile && (
          <div className="back_box" onClick={handleBack}>
            &lt; {t('As_Login&SignupPage_Backward')}
          </div>
        )}
        {countdownNum > 0 && (
          <>
            <div className="countdown_text">
              {t('As_Login&SignupPage_ConfirmLogin2')}
              {t('As_Login&SignupPage_Resend2')} <span>{countdownNum}</span>
              {t('As_Login&SignupPage_ResendTimeLim')}
            </div>
            {isMobile && (
              <div className="back_box" onClick={handleBack}>
                &lt; {t('As_Login&SignupPage_Backward')}
              </div>
            )}
          </>
        )}
        {countdownNum <= 0 &&
          (isMobile ? (
            <>
              <div className="resend_text">
                {t('As_Login&SignupPage_ConfirmLogin2')}
                <span onClick={handleResendNum}>{t('As_Login&SignupPage_Resend')}</span>
              </div>
              <div className="back_box" onClick={handleBack}>
                &lt; {t('As_Login&SignupPage_Backward')}
              </div>
            </>
          ) : (
            <div className="resend_text">
              {t('As_Login&SignupPage_ConfirmLogin2')}
              <span onClick={handleResendNum}>{t('As_Login&SignupPage_Resend')}</span>
            </div>
          ))}
      </div>
    </div>
  );
}
